<script>
  import options from './ChatMessageCard.options'
  export default options
</script>


<template>
  <li class="nyk-chat-message-card nyk-standard-card nyk-standard-card--no-image">
    <a :href="href" target="_blank" class="nyk-standard-card__content nyk-chat-message-card__link">
      <div class="nyk-standard-card__content__body">
          <div class="nyk-standard-card__content__body__content">
              <h3 class="nyk-chat-message-card__link__title nyk-standard-card__content__body__content__title">{{ title }}</h3>
          </div>
      </div>
      <div class="nyk-standard-card__content__footer">
        <div class="nyk-standard-card__content__footer__link" id="nyk-standard-card__content__footer__link-2070445">
            {{ readmoreLabel }}
            <div class="nyk-standard-card__content__footer__link__button nyk-button nyk-button--link-circle-arrow right">
                <div class="nyk-button__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12" role="presentation"><path fill="#07094A" d="M0 5.393v1.231h11.37l-3.898 4.243.67.633L14 5.991 8.142.5l-.67.633 3.898 4.26H0Z"></path></svg>
                </div>
            </div>
        </div>
      </div>
    </a>
  </li>
</template>
